import { Provider } from '@angular/core';
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
  provideNativeDateAdapter,
} from '@angular/material/core';

/**
 * Material datepicker display/parse formats matching the platform date format
 * (`dd/MM/yyyy`). Combined with the `en-GB` locale below, the native date
 * adapter renders picker inputs and calendar labels in day-first numeric form.
 */
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};

/**
 * Global providers that make every Angular Material datepicker show and accept
 * `dd/MM/yyyy`. Provided once at the app root; components no longer need their
 * own `provideNativeDateAdapter()`.
 */
export function provideAppDateAdapter(): Provider[] {
  return [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ];
}
